module.exports = __webpack_public_path__ + "img/keypal-plus-light.1a3b327c.png";